<template>
    <div class="one-bd clearfix">
        <router-link to="/taskOrders" exact :class="$route.meta.pageActive==3?'router-link-active':''">待办任务</router-link>
        <a href="javascript:void(0);" @click="sendOrder();" :class="$route.meta.pageActive==2?'router-link-active':''">发布指令<i class="icons icon-lock" v-if="$parent.$parent.vipInfo.task === 0"></i></a>
        <!-- <router-link to="/taskOrders/articleReview" exact>文章审核</router-link>
        <router-link to="/taskOrders/taskMyArticle" exact>我的文章</router-link> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
           task:'',
           active:false,
        }
    },
    mounted() {
        let that = this;
        this.$nextTick(()=> {
           
        })
    },
    created() {
		
    },
    methods: {
        // 发布指令
        sendOrder () {
            let that = this;
            let task = that.$parent.$parent.vipInfo.task;
            that.task = task;
            if(task === 0){//没有权限
                let html = '您没有此权限，请<span class="color-blue">联系管理员开通</span>';
                that.$parent.$parent.alertTips(html);
            }else{
                that.$router.push({path:'/taskOrders/issueOrders'});
                that.active =true;
            }
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/taskOrders/taskOrdersMenu.vue